import { API } from "./ApiConfig";
const URL_GRUPO = "/parametros";
const GET_UBICAR_PARAMETROS = "/ubicarParametros";
const GET_UBICAR_PARAM = "/ubicarParamUnico";
const GET_UBICAR_MODULOS = "/ubicarModulos";
const GET_UBICAR_TIPOS = "/ubicarTipos";
const GET_UBICAR_TIPOS_CONJUNTO = "/ubicarTiposConjunto";
const GET_UBICAR_OPCIONES = "/ubicarOpciones";
const GET_UBICAR_OPCION = "/ubicarOpcionIndividual";

const GET_UBICAR_VEHICULOS = "/ubicarVehiculos";
const URL_GUARDAR_PARAM_INICIAL = "/guardarParametroInicial";
const URL_GET_PARAM_INICIAL = "/getParametroInicial";
const GET_GUARDAR_PARAM = "/guardarParametro";
const GET_CREAR_GRUPO = "/crearGrupo";
const GET_EDITAR_PARAM = "/editarParametro";
const GET_ELIMINAR_PARAM = "/eliminarParametro";

//get ubicar los parametros
export const GetUbicarParamUnicoRequest = async (data) => {
  const request = await API.post(URL_GRUPO + GET_UBICAR_PARAM, data);
  const response = request.data;
  return response;
};

export const GetUbicarParametrosRequest = async (tipo_param) => {
  const request = await API.get(URL_GRUPO + GET_UBICAR_PARAMETROS + `/${tipo_param}`);
  const response = request.data;
  return response;
};

export const GetUbicarModulosRequest = async (tipo_param) => {
  const request = await API.get(URL_GRUPO + GET_UBICAR_MODULOS + `/${tipo_param}`);
  const response = request.data;
  return response;
};

export const GetUbicarTiposRequest = async (tipo_param) => {
  const request = await API.get(URL_GRUPO + GET_UBICAR_TIPOS + `/${tipo_param}`);
  const response = request.data;
  return response;
};

export const GetUbicarTiposConjuntoRequest = async () => {
  const request = await API.get(URL_GRUPO + GET_UBICAR_TIPOS_CONJUNTO);
  const response = request.data;
  return response;
};

export const GetUbicarOpcionesRequest = async (tipo_param) => {
  const request = await API.get(URL_GRUPO + GET_UBICAR_OPCIONES + `/${tipo_param}`);
  const response = request.data;
  return response;
};

export const UbicarOpcionIndividualRequest = async (tipo_param) => {
  const request = await API.get(URL_GRUPO + GET_UBICAR_OPCION + `/${tipo_param}`);
  const response = request.data;
  return response;
};

export const GetUbicarVehiculosRequest = async (id) => {
  const request = await API.get(URL_GRUPO + GET_UBICAR_VEHICULOS + `/${id}`);
  const response = request.data;
  return response;
};

export const GuardarParametroRequest = async (data) => {
  const request = await API.post(URL_GRUPO + GET_GUARDAR_PARAM, data);
  const response = request.data;
  return response;
};
// para parametros iniciales
export const GuardarParamInicalRequest = async (data) => {
  const request = await API.post(URL_GRUPO + URL_GUARDAR_PARAM_INICIAL, data);
  const response = request.data;
  return response;
};
// get parametros iniciales
export const GetParamInicialRequest = async () => {
  const request = await API.get(URL_GRUPO + URL_GET_PARAM_INICIAL);
  const response = request.data;
  return response;
};
///////////////////////////////////////////////////////////////

export const CrearGrupoRequest = async (data) => {
  const request = await API.post(URL_GRUPO + GET_CREAR_GRUPO, data);
  const response = request.data;
  return response;
};

//editar un parametro
export const PostEditarParametroRequest = async (id, data) => {
  // console.log('data e id');
  // console.log(data);
  // console.log(id);
  const request = await API.post(URL_GRUPO + GET_EDITAR_PARAM + `/${id}`, data);
  const response = request.data;
  return response;
};

//Elimianr un parametro
export const EliminarParamRequest = async (data) => {
  const request = await API.post(URL_GRUPO + GET_ELIMINAR_PARAM, data);
  const response = request.data;
  return response;
};

